import { defineStore, acceptHMRUpdate } from "pinia";
import { brogglBack } from "../axios.js";

export const useTeamStore = defineStore("team", {
  state: () => ({
    teams: [],
    team: {},
    teamMembers: [],
    notTeamMembers: [],
    loading: true,
  }),
  getters: {
    getTeams: (state) => {
      return state.teams;
    },
    getTeam: (state) => {
      return state.team;
    },
    getTeamMembers: (state) => {
      return state.teamMembers;
    },
    getNotTeamMembers: (state) => {
      return state.notTeamMembers;
    },
    getLoading: (state) => {
      return state.loading;
    },
  },
  actions: {
    async fetchTeams() {
      try {
        const res = await brogglBack.get("/team/teams-members", {
          headers: {
            Authorization: "Bearer " + window.$cookies.get("jwt"),
          },
        });
        this.teams = res.data.data;
        this.loaded = false;
      } catch (err) {
        console.log(err);
      }
    },
    async fetchTeamVue(teamId) {
      try {
        const res = await brogglBack.get("/team-members/team-vue", {
          headers: {
            Authorization: "Bearer " + window.$cookies.get("jwt"),
          },
          params: {
            teamId: teamId,
          },
        });
        this.team = res.data.data.team;
        this.teamMembers = res.data.data.teamMembers;
        this.notTeamMembers = res.data.data.notTeamMembers;
        this.notTeamMembers.sort((a, b) => a.Name.localeCompare(b.Name));
      } catch (err) {
        console.log(err);
      }
    },
    async addTeamMember(userId, teamId) {
      await brogglBack
        .get("/team-members/create", {
          headers: {
            Authorization: "Bearer " + window.$cookies.get("jwt"),
          },
          params: {
            teamId: teamId,
            userId: userId,
          },
        })
        .then((response) => {
          this.fetchTeamVue(teamId);
        });
    },
    async removeTeamMember(teamMemberId, teamId) {
      await brogglBack
        .delete("/team-members/destroy", {
          headers: {
            Authorization: "Bearer " + window.$cookies.get("jwt"),
          },
          params: {
            id: teamMemberId,
          },
        })
        .then((response) => {
          this.fetchTeamVue(teamId);
        });
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTeamStore, import.meta.hot));
}
